
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("hydSe", function(module, exports) {

$parcel$export(module.exports, "ContextualCreateContentPopoverLoader", () => $bb63054715080228$export$e1b8a1ae03e64401);
$parcel$export(module.exports, "TreeBottomCreateButton", () => $bb63054715080228$export$1546232e68d28255);
/* TreeBottomCreateButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $j2DHo = parcelRequire("j2DHo");

var $inPa6 = parcelRequire("inPa6");

var $jmjWc = parcelRequire("jmjWc");
var $luv00 = parcelRequire("luv00");

var $gz8ZY = parcelRequire("gz8ZY");

var $6mKj3 = parcelRequire("6mKj3");

var $2to2n = parcelRequire("2to2n");

var $3e1an = parcelRequire("3e1an");

const $bb63054715080228$export$e1b8a1ae03e64401 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9_LXb",
    name: "ContextualCreateContentPopoverLoader",
    loader: async ()=>(await (parcelRequire("4O0fl"))).ContextualCreateContentPopover
});
const $bb63054715080228$var$visibleStyle = null;
const $bb63054715080228$var$defaultStyle = null;
const $bb63054715080228$export$1546232e68d28255 = ({ cohort: cohort, isCreateFromContentTreeEligible: isCreateFromContentTreeEligible, spaceKey: spaceKey, source: source })=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const [buttonRef, inView] = (0, $j2DHo.useInView)({
        triggerOnce: true
    });
    const offset = isNav4Enabled ? (0, $2to2n.NAV4_POPOVER_OFFSET) : [
        0,
        6
    ];
    const [, fireCreateFromContentTreeExperiment] = (0, $6mKj3.UNSAFE_noExposureExp)('confluence_create_from_content_tree_experiment');
    (0, $gwFzn.useEffect)(()=>{
        if (inView) {
            fireCreateFromContentTreeExperiment();
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'exposed',
                    actionSubject: 'feature',
                    attributes: {
                        flagKey: (0, $3e1an.CREATE_FROM_CONTENT_TREE_EXPERIMENT),
                        value: cohort
                    },
                    source: source
                }
            }).fire();
        }
    }, [
        inView,
        cohort,
        createAnalyticsEvent,
        source,
        fireCreateFromContentTreeExperiment
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        ref: buttonRef,
        "data-testid": "page-tree-create-button",
        "data-vc": "page-tree-create-button",
        ...ssrPlaceholderIdProp,
        className: (0, $35pXk.default)([
            "_4t3iidpf",
            isCreateFromContentTreeEligible && "_4t3i1wug"
        ])
    }, isCreateFromContentTreeEligible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($bb63054715080228$export$e1b8a1ae03e64401, {
        spaceKey: spaceKey,
        source: source,
        isTreeItem: true,
        offset: offset,
        placement: "bottom-start",
        shouldRenderToParent: true
    }));
};

});
parcelRegister("j2DHo", function(module, exports) {

$parcel$export(module.exports, "useInView", () => $ddccff9ce8e822fb$export$2f62ee6831462844);

var $gwFzn = parcelRequire("gwFzn");
"use client";
var $ddccff9ce8e822fb$var$__defProp = Object.defineProperty;
var $ddccff9ce8e822fb$var$__defNormalProp = (obj, key, value)=>key in obj ? $ddccff9ce8e822fb$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $ddccff9ce8e822fb$var$__publicField = (obj, key, value)=>$ddccff9ce8e822fb$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value); // src/InView.tsx
// src/observe.ts
var $ddccff9ce8e822fb$var$observerMap = /* @__PURE__ */ new Map();
var $ddccff9ce8e822fb$var$RootIds = /* @__PURE__ */ new WeakMap();
var $ddccff9ce8e822fb$var$rootId = 0;
var $ddccff9ce8e822fb$var$unsupportedValue = void 0;
function $ddccff9ce8e822fb$export$2ef3a60ee1f37bec(inView) {
    $ddccff9ce8e822fb$var$unsupportedValue = inView;
}
function $ddccff9ce8e822fb$var$getRootId(root) {
    if (!root) return "0";
    if ($ddccff9ce8e822fb$var$RootIds.has(root)) return $ddccff9ce8e822fb$var$RootIds.get(root);
    $ddccff9ce8e822fb$var$rootId += 1;
    $ddccff9ce8e822fb$var$RootIds.set(root, $ddccff9ce8e822fb$var$rootId.toString());
    return $ddccff9ce8e822fb$var$RootIds.get(root);
}
function $ddccff9ce8e822fb$var$optionsToId(options) {
    return Object.keys(options).sort().filter((key)=>options[key] !== void 0).map((key)=>{
        return `${key}_${key === "root" ? $ddccff9ce8e822fb$var$getRootId(options.root) : options[key]}`;
    }).toString();
}
function $ddccff9ce8e822fb$var$createObserver(options) {
    const id = $ddccff9ce8e822fb$var$optionsToId(options);
    let instance = $ddccff9ce8e822fb$var$observerMap.get(id);
    if (!instance) {
        const elements = /* @__PURE__ */ new Map();
        let thresholds;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                var _a;
                const inView = entry.isIntersecting && thresholds.some((threshold)=>entry.intersectionRatio >= threshold);
                if (options.trackVisibility && typeof entry.isVisible === "undefined") entry.isVisible = inView;
                (_a = elements.get(entry.target)) == null || _a.forEach((callback)=>{
                    callback(inView, entry);
                });
            });
        }, options);
        thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [
            options.threshold || 0
        ]);
        instance = {
            id: id,
            observer: observer,
            elements: elements
        };
        $ddccff9ce8e822fb$var$observerMap.set(id, instance);
    }
    return instance;
}
function $ddccff9ce8e822fb$export$d1203567a167490e(element, callback, options = {}, fallbackInView = $ddccff9ce8e822fb$var$unsupportedValue) {
    if (typeof window.IntersectionObserver === "undefined" && fallbackInView !== void 0) {
        const bounds = element.getBoundingClientRect();
        callback(fallbackInView, {
            isIntersecting: fallbackInView,
            target: element,
            intersectionRatio: typeof options.threshold === "number" ? options.threshold : 0,
            time: 0,
            boundingClientRect: bounds,
            intersectionRect: bounds,
            rootBounds: bounds
        });
        return ()=>{};
    }
    const { id: id, observer: observer, elements: elements } = $ddccff9ce8e822fb$var$createObserver(options);
    const callbacks = elements.get(element) || [];
    if (!elements.has(element)) elements.set(element, callbacks);
    callbacks.push(callback);
    observer.observe(element);
    return function unobserve() {
        callbacks.splice(callbacks.indexOf(callback), 1);
        if (callbacks.length === 0) {
            elements.delete(element);
            observer.unobserve(element);
        }
        if (elements.size === 0) {
            observer.disconnect();
            $ddccff9ce8e822fb$var$observerMap.delete(id);
        }
    };
} // src/InView.tsx
function $ddccff9ce8e822fb$var$isPlainChildren(props) {
    return typeof props.children !== "function";
}
var $ddccff9ce8e822fb$export$a62107ca74432f44 = class extends $gwFzn.Component {
    componentDidMount() {
        this.unobserve();
        this.observeNode();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
            this.unobserve();
            this.observeNode();
        }
    }
    componentWillUnmount() {
        this.unobserve();
    }
    observeNode() {
        if (!this.node || this.props.skip) return;
        const { threshold: threshold, root: root, rootMargin: rootMargin, trackVisibility: trackVisibility, delay: delay, fallbackInView: fallbackInView } = this.props;
        this._unobserveCb = $ddccff9ce8e822fb$export$d1203567a167490e(this.node, this.handleChange, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin,
            trackVisibility: // @ts-ignore
            trackVisibility,
            delay: // @ts-ignore
            delay
        }, fallbackInView);
    }
    unobserve() {
        if (this._unobserveCb) {
            this._unobserveCb();
            this._unobserveCb = null;
        }
    }
    render() {
        const { children: children } = this.props;
        if (typeof children === "function") {
            const { inView: inView, entry: entry } = this.state;
            return children({
                inView: inView,
                entry: entry,
                ref: this.handleNode
            });
        }
        const { as: as, triggerOnce: triggerOnce, threshold: threshold, root: root, rootMargin: rootMargin, onChange: onChange, skip: skip, trackVisibility: trackVisibility, delay: delay, initialInView: initialInView, fallbackInView: fallbackInView, ...props } = this.props;
        return $gwFzn.createElement(as || "div", {
            ref: this.handleNode,
            ...props
        }, children);
    }
    constructor(props){
        super(props);
        $ddccff9ce8e822fb$var$__publicField(this, "node", null);
        $ddccff9ce8e822fb$var$__publicField(this, "_unobserveCb", null);
        $ddccff9ce8e822fb$var$__publicField(this, "handleNode", (node)=>{
            if (this.node) {
                this.unobserve();
                if (!node && !this.props.triggerOnce && !this.props.skip) this.setState({
                    inView: !!this.props.initialInView,
                    entry: void 0
                });
            }
            this.node = node ? node : null;
            this.observeNode();
        });
        $ddccff9ce8e822fb$var$__publicField(this, "handleChange", (inView, entry)=>{
            if (inView && this.props.triggerOnce) this.unobserve();
            if (!$ddccff9ce8e822fb$var$isPlainChildren(this.props)) this.setState({
                inView: inView,
                entry: entry
            });
            if (this.props.onChange) this.props.onChange(inView, entry);
        });
        this.state = {
            inView: !!props.initialInView,
            entry: void 0
        };
    }
};
function $ddccff9ce8e822fb$export$2f62ee6831462844({ threshold: threshold, delay: delay, trackVisibility: trackVisibility, rootMargin: rootMargin, root: root, triggerOnce: triggerOnce, skip: skip, initialInView: initialInView, fallbackInView: fallbackInView, onChange: onChange } = {}) {
    var _a;
    const [ref, setRef] = $gwFzn.useState(null);
    const callback = $gwFzn.useRef(onChange);
    const [state, setState] = $gwFzn.useState({
        inView: !!initialInView,
        entry: void 0
    });
    callback.current = onChange;
    $gwFzn.useEffect(()=>{
        if (skip || !ref) return;
        let unobserve;
        unobserve = $ddccff9ce8e822fb$export$d1203567a167490e(ref, (inView, entry)=>{
            setState({
                inView: inView,
                entry: entry
            });
            if (callback.current) callback.current(inView, entry);
            if (entry.isIntersecting && triggerOnce && unobserve) {
                unobserve();
                unobserve = void 0;
            }
        }, {
            root: root,
            rootMargin: rootMargin,
            threshold: threshold,
            trackVisibility: // @ts-ignore
            trackVisibility,
            delay: // @ts-ignore
            delay
        }, fallbackInView);
        return ()=>{
            if (unobserve) unobserve();
        };
    }, // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        // If the threshold is an array, convert it to a string, so it won't change between renders.
        Array.isArray(threshold) ? threshold.toString() : threshold,
        ref,
        root,
        rootMargin,
        triggerOnce,
        skip,
        trackVisibility,
        fallbackInView,
        delay
    ]);
    const entryTarget = (_a = state.entry) == null ? void 0 : _a.target;
    const previousEntryTarget = $gwFzn.useRef(void 0);
    if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
        previousEntryTarget.current = entryTarget;
        setState({
            inView: !!initialInView,
            entry: void 0
        });
    }
    const result = [
        setRef,
        state.inView,
        state.entry
    ];
    result.ref = result[0];
    result.inView = result[1];
    result.entry = result[2];
    return result;
}

});

parcelRegister("4O0fl", function(module, exports) {

let $37fc05e66793cefc$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $37fc05e66793cefc$var$load("11tIB"),
    $37fc05e66793cefc$var$load("cQaiz"),
    $37fc05e66793cefc$var$load("4JkkU"),
    $37fc05e66793cefc$var$load("hkGfe"),
    $37fc05e66793cefc$var$load("gOjQr"),
    $37fc05e66793cefc$var$load("gPhf6"),
    $37fc05e66793cefc$var$load("c0kqt"),
    $37fc05e66793cefc$var$load("juVlo"),
    $37fc05e66793cefc$var$load("dY7M5"),
    $37fc05e66793cefc$var$load("joJy8"),
    $37fc05e66793cefc$var$load("aHE9G"),
    $37fc05e66793cefc$var$load("9F7vX")
]).then(()=>parcelRequire('k9zbN'));

});



//# sourceMappingURL=TreeBottomCreateButton.81af99f1.js.map
